module.exports = __webpack_public_path__ + "static/us-pop2-6d3e511d7a0fe0e509b943986e02d4e9.png";